module.exports = __webpack_public_path__ + "static/media/misPagos.53fba2e8.svg";